import axios from 'axios'
import { ApiConfig } from '../../../config/api'
import { Filter } from '../../../components/_WMS/FilterComponent'
import { GenericOrderBy } from '../../../components/_EOS/Table'
import { ProductOrigin } from '../../../interfaces/Producto/ProductOrigins'
import { getProductsOrigins } from '../../ProductOrigin/api'

export const getProductOriginsTechnical = (
  filters: Filter[],
  page: number,
  pageSize: number,
  orderBy?: GenericOrderBy<ProductOrigin>
) => {
  return getProductsOrigins(
    filters,
    orderBy as GenericOrderBy<ProductOrigin>,
    page,
    pageSize
  )
}

export interface ProductOriginTechnicalPayload {
  productOriginId: number
  origin: string
  name: string
  orderOriginIds: number[]
  productExternalReferencesIds: number[]
  isActive: boolean
}

export const createProductOriginTechnical = (
  data: ProductOriginTechnicalPayload
) => {
  return axios.post(`${ApiConfig.ProductOriginApi}/TechnicalCreate`, data)
}

export const updateProductOriginTechnical = (
  productOriginId: number,
  data: ProductOriginTechnicalPayload
) => {
  return axios.patch(
    `${ApiConfig.ProductOriginApi}/TechnicalUpdate/${productOriginId}`,
    data
  )
}
